/* eslint-disable no-useless-return */
/* eslint-disable no-alert */
/* eslint-disable no-restricted-globals */
/* eslint-disable react/forbid-prop-types */
import React from 'react';
import PropTypes from 'prop-types';
import { ProductRanges } from 'models/business/Ad';
import StyledRadioButton from 'components/pages/ResourceSetting/Widgets/StyledRadioButton';
import Styles from './index.module.css';

export default function ProductRangeRadio({
  value,
  onChange,
  contentFeed,
  setContentFeed,
}) {
  return (
    <div className={Styles.mainContainer}>
      <StyledRadioButton
        className={Styles.productRangeButton}
        selected={value === ProductRanges.Total}
        onClick={() => {
          if (contentFeed.local) {
            const answer = confirm('改為投放全館商品將刪除已上傳的投放部分商品清單?');
            if (answer) {
              setContentFeed();
              onChange(ProductRanges.Total);
            } else return;
          } else {
            onChange(ProductRanges.Total);
          }
        }}
      >
        全館商品
      </StyledRadioButton>
      <StyledRadioButton
        className={Styles.productRangeButton}
        selected={value === ProductRanges.Selected}
        onClick={() => onChange(ProductRanges.Selected)}
      >
        <div>僅投放部分商品</div>
        <div style={{ fontSize: 15 }}>
          建議投放20品以上
        </div>
      </StyledRadioButton>
    </div>
  );
}

ProductRangeRadio.propTypes = {
  value: PropTypes.string,
  onChange: PropTypes.func,
  setContentFeed: PropTypes.func,
  contentFeed: PropTypes.object,
};

ProductRangeRadio.defaultProps = {
  value: '',
  onChange: () => {},
  setContentFeed: () => {},
  contentFeed: {},
};
